import clsx from 'clsx';

import s from './inputs.module.scss';

export const FormGroup = ({
  label,
  className,
  children,
  cols,
}: {
  label: string;
  className?: string;
  children?: React.ReactNode;
  cols: number;
}) => {
  return (
    <div className={clsx(s.FormGroup, className)}>
      <p className={clsx(s.Label, className)}>{label}</p>
      <div className={s.body} style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
        {children}
      </div>
    </div>
  );
};
